import { useMutation, useQueryClient } from '@tanstack/react-query';

import type { NewAssignment } from '@/openapi';
import { ScheduleService } from '@/openapi';
import { queryKeys } from '@/util/queryKeys';

export const useNewAssignmentMutation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (assignment: NewAssignment) => {
      return ScheduleService.scheduleServiceCreateAssignment({
        body: assignment,
      });
    },
    onSettled: async () => {
      await Promise.all([
        queryClient.invalidateQueries({ queryKey: queryKeys.schedule.all }),
        queryClient.invalidateQueries({
          queryKey: queryKeys.holidays.withShifts(),
        }),
      ]);
    },
  });
};
